import React from 'react';
import { MessageSquareIcon } from 'lucide-react';
import { VENDOR_EXAMPLE } from '../../../data/exampleReviews';
import { ExampleFrame } from '../../examples/ExampleFrame';
import { StatusPill } from '../../examples/StatusPill';
export function VendorComparison() {
  return <ExampleFrame title="Vendor comparison" subtitle="Field service platform · 2 vendors" caption="Fictional vendors and requirements." data-id="element-1057" data-mp="2q4jglrl9x3uo">
      <div className="overflow-x-auto" data-id="element-1058" data-mp="2l6hyp9zl3aks">
        <table className="w-full min-w-[320px] text-left text-sm" data-id="element-1059" data-mp="2l3dp1x3cnmmq">
          <caption className="sr-only" data-id="element-1060" data-mp="2g5lyp7ics8kn">Requirements and evidence status for each vendor</caption>
          <thead data-id="element-1061" data-mp="2b826t4sqfxa8">
            <tr className="border-b border-hairline text-[11px] uppercase tracking-[0.08em] text-text-tertiary" data-id="element-1062" data-mp="2b7kfmmkxg996">
              <th scope="col" className="py-2 pr-3 font-semibold" data-id="element-1063" data-mp="277s5i5fvxv1p">Requirement</th>
              {VENDOR_EXAMPLE.vendors.map(vendor => <th key={vendor} scope="col" className="px-2 py-2 font-semibold" data-id="element-1064" data-mp="5dspj6rtipio">{vendor}</th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-hairline-soft" data-id="element-1065" data-mp="g32cwnwc7wkj">
            {VENDOR_EXAMPLE.requirements.map(row => <tr key={row.requirement} data-id="element-1066" data-mp="l13wrb1l7zx2">
                <th scope="row" className="py-2.5 pr-3 font-medium text-text-primary" data-id="element-1067" data-mp="74h079djrbro">{row.requirement}</th>
                {row.statuses.map((status, index) => <td key={VENDOR_EXAMPLE.vendors[index]} className="px-2 py-2.5" data-id="element-1068" data-mp="yuv7gmr21pud" data-mpi={index}>
                    <StatusPill status={status} data-id="element-1069" data-mp="ywy4vrujel94" />
                  </td>)}
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-4 flex gap-2.5 rounded-xl border border-hairline-soft bg-surface px-3.5 py-3" data-id="element-1070" data-mp="q1rwqm7snr3f">
        <MessageSquareIcon className="mt-0.5 h-4 w-4 shrink-0 text-lime" aria-hidden="true" data-id="element-1071" data-mp="u2tvz31po35e" />
        <div data-id="element-1072" data-mp="1hsxq8jt0eqjq">
          <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-text-tertiary" data-id="element-1073" data-mp="1hs62tw9kfz4j">{VENDOR_EXAMPLE.note.author}</p>
          <p className="mt-0.5 text-sm text-text-primary" data-id="element-1074" data-mp="1wgfy1r1vc1ad">{VENDOR_EXAMPLE.note.text}</p>
        </div>
      </div>
    </ExampleFrame>;
}